import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
const _hoisted_2 = ["innerHTML"]

import { readAsDataUrl } from '@packages/toolbox/dist/utils/file-readers';
import PDF from 'pdf-vue3';
import { computed, onMounted, ref, watch } from 'vue';

import useFileApi from 'SharedDir/common/composables/useFileApi';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import FilePreviewDocx from 'SharedDir/components/ui/File/FilePreviewDocx.vue';
import FilePreviewXlsx from 'SharedDir/components/ui/File/FilePreviewXlsx.vue';
import { ExcelExtensions, ImageExtensions, WordExtensions } from 'SharedDir/constants/files';
import { AttachmentType } from 'SharedDir/declarations/files';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FilePreview', components: { FilePreviewDocx, FilePreviewXlsx } },
  __name: 'FilePreview',
  props: {
    fileData: {}
  },
  setup(__props: any) {

function convertTextToHTML(text: string): string {
  const lines = text.split('\n');
  const htmlLines = lines.map((line) => `<div>${line}</div>`);
  return htmlLines.join('');
}

function readAsText(data) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsText(data);
    reader.onloadend = function loadend() {
      resolve(
        reader.result && typeof reader.result === 'string' ? convertTextToHTML(reader.result) : ''
      );
    };
    reader.onerror = function error() {
      resolve(reader.error);
    };
  });
}

const props = __props;

const { getBlobContent } = useFileApi();

const base64Content = ref<string>();
const blobContent = ref<Blob>();
const fileContent = ref<File>();
const plainContent = ref<string>();

const itIsWord = computed(() => WordExtensions.includes(props.fileData.extension));
const itIsPdf = computed(() => props.fileData.extension === 'pdf');
const itIsExcel = computed(() => ExcelExtensions.includes(props.fileData.extension));
const itIsImage = computed(() => ImageExtensions.includes(props.fileData.extension));
const itIsTxt = computed(() => props.fileData.extension === 'txt');

const showPreviewFile = () =>
  makeRequest(async () => {
    base64Content.value = null;
    fileContent.value = null;
    plainContent.value = null;
    blobContent.value = await getBlobContent(props.fileData.id);
    if (itIsPdf.value || itIsImage.value) {
      base64Content.value = await readAsDataUrl(blobContent.value);
      return;
    }
    if (itIsTxt.value) {
      plainContent.value = await readAsText(blobContent.value);
      return;
    }
    if (itIsExcel.value) {
      fileContent.value = new File([blobContent.value], props.fileData.name, {
        lastModified: Date.now(),
      });
    }
  });

watch(() => props.fileData, showPreviewFile);
onMounted(showPreviewFile);

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (itIsWord.value)
      ? (_openBlock(), _createBlock(FilePreviewDocx, {
          key: 0,
          src: blobContent.value
        }, null, 8, ["src"]))
      : (itIsPdf.value)
        ? (_openBlock(), _createBlock(_unref(PDF), {
            key: 1,
            src: base64Content.value,
            "pdf-width": "80%"
          }, null, 8, ["src"]))
        : (itIsExcel.value)
          ? (_openBlock(), _createBlock(FilePreviewXlsx, {
              key: 2,
              file: fileContent.value
            }, null, 8, ["file"]))
          : (itIsImage.value)
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 3,
                fit: "scale-down",
                src: base64Content.value
              }, null, 8, ["src"]))
            : (itIsTxt.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  innerHTML: plainContent.value
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
  ]))
}
}

})